<template>
  <div class="ptrl-22-16 box-s fz-14 fw-500 mb-10">
    <div class="l-h-14 c1 mb-18">标题内容</div>
      <ul class="flex-wrap text-center">
       <li class="wh_36 every_a b-radius-50 l-h-36 mr-15 mb-22" v-for="(item, index) in list" :key="index" :class="{ 'blue': item.is_result == 1, 'red': item.is_result == 2, 'white': item.is_result == 3, 'gray': item.is_result == 0 }" @click="getEvery(item, index)">{{index + 1}}</li>
      </ul>

      <div class="flexs flex-center c0 fz-12 mr-18">
        <div class="flexs mrb-26">
          <div class="wh_8 b-radius-50 bg_49 "></div>
          <div class="ml-8">答对</div>
        </div>
        <div class="flexs mrb-26">
          <div class="wh_8 b-radius-50 bg_3c"></div>
          <div class="ml-8">答错</div>
        </div>
        <div class="flexs mrb-26">
          <div class="wh_8 b-radius-50 bl_bg"></div>
          <div class="ml-8">主观题</div>
        </div>
        <div class="flexs">
          <div class="wh_8 b-radius-50 wh_bg9"></div>
          <div class="ml-8">未答</div>
        </div>
      </div>
      <div class="btn_contain">
      <div class="blue_btn mb-16" @click="getEmptyReturn">
        清理答题记录重做
      </div>

      <div class="card_btn" @click="getReturn">
        返回答题
      </div>
    </div>
    <loading :loadFlag="loadFlag"></loading>
    </div>
</template>
<script>
	import loading from "@/components/loading"
	import { siteRandomAnswerSheet, siteRandomClearHistory  } from '@/api/api';
	import {getShowPadding} from "@/utils/common.js";
	export default {
		components: {
      loading
		},
		data() {
			return {
				padShow: false,
        list: [],
        loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},
		methods: {
      async initData(){
        this.loadFlag = true
        const res = await siteRandomAnswerSheet({ examination_id: this.$route.query.examination_id })
        this.loadFlag = false
        if(res.code == 1000){
          this.list = res.data
        } else {
            this.$toast(res.msg)
          }
      },

      // 跳转回点击题目
      getEvery(item, index){
        this.$router.replace({ path: '/testquesttxt', query: { examination_id: this.$route.query.examination_id, qusetNum: index + 1 } })
      },

      // 清空答题卡返回做题
      async getEmptyReturn(){
         if(!this.list.some(item => item.is_result != 0)){
          return this.$toast('未答题，无需清空')
        }
        const res = await siteRandomClearHistory({ examination_id: this.$route.query.examination_id })
        if( res.code == 1000 ){
          this.$router.replace({ path: '/testquesttxt', query: { examination_id: this.$route.query.examination_id } })
        } else {
            this.$toast(res.msg)
          }
        
      },
      
      // 重新答题
      getReturn(){
        this.$router.replace({ path: '/testquesttxt', query: { examination_id: this.$route.query.examination_id, qusetNum: this.$route.query.qusetNum } })
      }
		}
	};
</script>
<style lang="less" scoped>
.wh_bg {
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
}

.every_a:nth-child(7n) {
  margin-right: 0;
}

</style>
